import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KtListClass;
function KtList() {
  if (KtListClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'List', VOID, VOID, [Collection()]);
    KtListClass = $;
  }
  return KtListClass;
}
var IterableClass;
function Iterable() {
  if (IterableClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Iterable');
    IterableClass = $;
  }
  return IterableClass;
}
var CollectionClass;
function Collection() {
  if (CollectionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Collection', VOID, VOID, [Iterable()]);
    CollectionClass = $;
  }
  return CollectionClass;
}
var EntryClass;
function Entry() {
  if (EntryClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Entry');
    EntryClass = $;
  }
  return EntryClass;
}
var KtMapClass;
function KtMap() {
  if (KtMapClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Map');
    KtMapClass = $;
  }
  return KtMapClass;
}
var KtMutableMapClass;
function KtMutableMap() {
  if (KtMutableMapClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MutableMap', VOID, VOID, [KtMap()]);
    KtMutableMapClass = $;
  }
  return KtMutableMapClass;
}
var KtSetClass;
function KtSet() {
  if (KtSetClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Set', VOID, VOID, [Collection()]);
    KtSetClass = $;
  }
  return KtSetClass;
}
var KtMutableSetClass;
function KtMutableSet() {
  if (KtMutableSetClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MutableSet', VOID, VOID, [KtSet(), MutableIterable(), Collection()]);
    KtMutableSetClass = $;
  }
  return KtMutableSetClass;
}
var KtMutableListClass;
function KtMutableList() {
  if (KtMutableListClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MutableList', VOID, VOID, [KtList(), MutableIterable(), Collection()]);
    KtMutableListClass = $;
  }
  return KtMutableListClass;
}
var MutableIterableClass;
function MutableIterable() {
  if (MutableIterableClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MutableIterable', VOID, VOID, [Iterable()]);
    MutableIterableClass = $;
  }
  return MutableIterableClass;
}
//region block: exports
export {
  Collection as Collection1k04j3hzsbod0,
  Iterable as Iterable1y3qizuf89iou,
  KtList as KtList3hktaavzmj137,
  Entry as Entry2xmjmyutzoq3p,
  KtMap as KtMap140uvy3s5zad8,
  MutableIterable as MutableIterablez3x4ksk1fmrm,
  KtMutableList as KtMutableList1beimitadwkna,
  KtMutableMap as KtMutableMap1kqeifoi36kpz,
  KtMutableSet as KtMutableSetwuwn7k5m570a,
  KtSet as KtSetjrjc7fhfd6b9,
};
//endregion

//# sourceMappingURL=Collections.mjs.map
